import React from 'react';
import {Tabs} from 'antd';
import {AuthTree} from '../AuthTree';
import {RoleAssign} from '../RoleAssign';

interface RolePanelProps {
    roleId: string;
}

export function RolePanel({roleId}: RolePanelProps) {
    return (
        <Tabs
            destroyInactiveTabPane
            items={[
                {
                    key: '1',
                    label: '功能权限',
                    children: <AuthTree roleId={roleId} />,
                },
                {
                    key: '2',
                    label: '分配人员',
                    children: <RoleAssign roleId={roleId} />,
                },
            ]}
        />
    );
}
